module.exports = require('./src/tinytabs.js');



//////////////////
// WEBPACK FOOTER
// ./node_modules/@htoniv/tiny-tabs/index.js
// module id = lexL
// module chunks = 0